import { Flex, theme, Typography } from 'antd';
import { MultiSelectEcho } from '@/components/echo/primitives';
import { uppercaseFirstLetter } from '@/utils';

interface MultiSelectItem {
  id: string;
  name?: string;
}

interface FiltersMultiSelectEchoProps {
  labelSingular: string;
  items: MultiSelectItem[];
  selectedIds: string[];
  allowClear?: boolean;
  maxCount?: number;
  onChange: (ids: string[]) => void;
  onOpen?: () => void;
}

const FiltersMultiSelectEcho = ({
  labelSingular,
  items,
  selectedIds,
  maxCount,
  allowClear = false,
  onChange,
  onOpen,
}: FiltersMultiSelectEchoProps) => {
  const { token } = theme.useToken();

  const options = items.map((item) => {
    return {
      value: item.id,
      // Fallback id if name is not provided
      label: item.name ?? item.id,
    };
  });

  return (
    <MultiSelectEcho
      maxCount={maxCount}
      allowClear={allowClear}
      id={`${labelSingular}-select`}
      showSearch={{ optionFilterProp: 'label' }}
      transparentTag
      onOpenChange={(open) => {
        if (open) onOpen?.();
      }}
      value={selectedIds}
      options={options}
      styles={{ placeholder: { color: token.colorText } }}
      onChange={onChange}
      maxTagCount={0}
      maxTagPlaceholder={() => (
        <Flex align="center" style={{ height: '100%' }}>
          <Typography.Text ellipsis>
            {getTriggerLabel(items, selectedIds, labelSingular)}
          </Typography.Text>
        </Flex>
      )}
      placeholder={`All ${labelSingular}s`}
      virtual={false}
    />
  );
};

const getTriggerLabel = (
  items: MultiSelectItem[],
  selectedIds: string[],
  labelSingular: string
): string => {
  const resolvedItems = items.filter((item) => selectedIds.includes(item.id));

  if (resolvedItems.length === 0) {
    return '';
  }

  if (resolvedItems.length === 1) {
    const [item] = resolvedItems;
    return `${uppercaseFirstLetter(labelSingular)}: ${item.name ?? item.id}`;
  }

  return `${resolvedItems.length} ${labelSingular}s selected`;
};

export default FiltersMultiSelectEcho;
